if (document.getElementById('vue-testimonials')) {
	Vue.use(VeeValidate);
	new Vue({
		delimiters: ['[[', ']]'],
		mixins: [baseMixin, eventHubMixin, headerMixin, languageMixin, apiMixin],
		el: '#vue-testimonials',
		data: {
			filter: {},
			residences: [],
			articles: [],
			testimonies: [],
			nextUrl: '',
			isLoading: false,
		},
		watch: {
			'filter.value': function (){
				this.getTestimonies();
			}
		},
		created() {
			this.$validator.localize('fr');
		},
		mounted() {
			this.getTestimonies();
			this.getResidences();
			this.getArticles();
		},
		methods: {
			getResidences() {
				this.get('dropdowns/residence-list', {}, false).then((response) => {
					this.residences = response.data.map(
						(el) => (response.data[el] = { label: el.label, value: el.value })
					);
				});
			},
			getTestimonies() {
				// console.log(this.residenceFilter)
				this.get('testimonies', {residence: this.filter.value}, false).then((response) => {
					this.testimonies = response.data.results;
					response.data.next ? (this.nextUrl = response.data.next) : (this.nextUrl = '');
				});
			},
			getArticles() {
				this.get('articles', { category__sites: window.site_id }, false)
					.then((response) => {
						this.articles = response.data.results;
						this.$nextTick(() => {
							initCarouselNews();
						});
					})
					.catch((error) => {
						// console.log(error);
					});
			},
			getAddress(address) {
				return address[0].city;
			},
			loadMore() {
				if (!this.isLoading) {
	this.isLoading = true;
		this.get(this.nextUrl, {}, true)
			.then((response) => {
	this.isLoading = false;
				response.data.next ? (this.nextUrl = response.data.next) : (this.nextUrl = '');
				this.testimonies = [...this.testimonies, ...response.data.results];
			})
			.catch((error) => {
	this.isLoading = false;
				// console.log(error);
	});
}
			}
		}
	});
}
